var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEur({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z",
    fill: "#0F8FF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 15.4408L7.15813 13.8125H7.85444C7.8364 13.5339 7.82719 13.2548 7.82681 12.9756C7.82681 12.6116 7.84225 12.2736 7.87231 11.96H6.5L7.15813 10.3326H8.19325C9.15687 7.23612 11.3295 5.6875 14.7087 5.6875C15.8194 5.6875 16.8748 5.83131 17.875 6.11975V8.1705C16.9337 7.74988 15.9135 7.53493 14.8826 7.54C12.857 7.54 11.5546 8.47113 10.9744 10.3334H17.0056L16.3475 11.9608H10.5812C10.5467 12.2289 10.5315 12.499 10.5357 12.7692C10.5357 13.1584 10.5479 13.5062 10.5722 13.8133H15.5959L14.9459 15.4408H10.92C11.3531 16.5693 11.8812 17.3542 12.5036 17.797C13.1251 18.239 14.0132 18.46 15.1661 18.46C15.99 18.46 16.8927 18.2593 17.875 17.8579V19.786C16.9414 20.137 15.8316 20.3125 14.5437 20.3125C11.1581 20.3125 9.01631 18.6883 8.12013 15.4408H6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/eur.9d76920c391d8c1818620db59d6919f7.svg";
export { ForwardRef as ReactComponent };